<template>
  <div class="mainContentPrivacy">
    <div class="agreementBox" v-html="content">
    </div>
    <!-- 我是服务协议，协议内容未确认，提审前确认。协议格式待确认后调整。 -->
  </div>
</template>
<script>
import { serviceInfo } from "@/const/agreement.js";
export default {
  data() {
    return {
      content: serviceInfo
    };
  },
  created() {
    // console.log("serviceInfo", serviceInfo);
  },
};
</script>
<style lang="less">
.mainContentPrivacy {
  width: 100%;
  height: 100vh;
  background-color: #f9f9f9;
  .agreementBox {
    font-size: 28px;
    line-height: 1.4em;
    padding: 20px;
    word-break: break-all;
    overflow: hidden;
    h3{
      margin: 20px 0
    }
    p{
      margin: 12px 0;
    }
  }
}
</style>
